[
	{
		"display": "false",
		"ui_columnname": "Action Type",
		"db_columnname": "actionType",
		"datatype": "String",
		"mappingkey": "actionType",
		"dropdown": "YES",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Error ROE ID",
		"db_columnname": "errorROEID",
		"datatype": "String",
		"mappingkey": "errorROEID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Firm ROE ID",
		"db_columnname": "firmROEID",
		"datatype": "String",
		"mappingkey": "firmROEID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Type",
		"db_columnname": "type",
		"datatype": "String",
		"mappingkey": "type",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "CAT Reporter IMID",
		"db_columnname": "CATReporterIMID",
		"datatype": "String",
		"mappingkey": "CATReporterIMID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "true",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Aggregated Order Key Date",
		"db_columnname": "aggOrderKeyDate",
		"datatype": "String",
		"mappingkey": "aggOrderKeyDate",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "true",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Aggregated Order ID",
		"db_columnname": "aggOrderID",
		"datatype": "String",
		"mappingkey": "aggOrderID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "false",
		"ui_columnname": "Symbol",
		"db_columnname": "symbol",
		"datatype": "String",
		"mappingkey": "symbol",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Order ID",
		"db_columnname": "orderID",
		"datatype": "String",
		"mappingkey": "orderID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Order Key Date",
		"db_columnname": "orderKeyDate",
		"datatype": "String",
		"mappingkey": "orderKeyDate",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Quantity",
		"db_columnname": "quantity",
		"datatype": "Int",
		"mappingkey": "quantity",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Originating IMID",
		"db_columnname": "originatingIMID",
		"datatype": "String",
		"mappingkey": "originatingIMID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	}
]